import(/* webpackMode: "eager", webpackExports: ["PondSceneV3"] */ "/vercel/path0/lib/koi-pond-v3/scene/PondSceneV3.tsx");
